import { ICollection } from "../types/ICollection";
import { HttpClient } from "./http/httpclient.service";
import { ApiRoutes } from "./http/routes";

export const FilterService = {
    getAllCollections: async (): Promise<ICollection[]> => {
        try {
            const response = await HttpClient.get<ICollection>({
                route: ApiRoutes.GetCollections,
            });
            return (response.data || []) as ICollection[];
        } catch (error) {
            console.error("Error adding collection to cart:", error);
            throw error;
        }
    }
}